<template>
    <div class="lost-connection-overlay">
        <wifi-exclamation width="40" style="color: orange;'" />
        <span>
            We zijn de verbinding met de AI Agent verloren.
        </span>
        <button
            class="lost-connection-overlay__button"
            type="button"
            @click="reload()"
        >
            Ververs de pagina
        </button>
    </div>
</template>

<script setup lang="ts">
    import WifiExclamation from '@keyvue/one-awesome-icons/icons/solid/wifi-exclamation.svg?component';

    function reload(): void {
        window.location.reload();
    }
</script>

<style scoped lang="scss">
    .lost-connection-overlay {
        background-color: white;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1.5rem 1.5rem;
        gap: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-top: solid 1px lightgray;
        transition: transform 200ms ease-in-out;
        transform: translateY(0);
        overflow-y: scroll;
        max-height: 100%;

        & > span {
            text-align: center;
        }

        &__button {
            background-color: var(--color-widget);
            color: var(--color-widget-text);
            border: none;
            font-weight: bold;
            border-radius: 10px;
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: .5rem 3rem .5rem 3.5rem;

            &:hover {
                filter: brightness(1.1);
            }

            &--disabled {
                background-color: #c3c3c3;
                cursor: unset;

                &:hover {
                    filter: none;
                }
            }
        }
    }
</style>
